module.exports = __webpack_public_path__ + "static/media/img-dentist-product-5@2x.4a2dd18f.png";